import { userOperatePageEventFragment } from "@saleor/fragments/pages";
import { shopFragment } from "@saleor/fragments/shop";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { SiteUri } from "./types/SiteUri";
import {
  UserOperatePageEvent,
  UserOperatePageEventVariables
} from "./types/UserOperatePageEvent";

const siteUri = gql`
  ${shopFragment}
  query SiteUri {
    shop {
      ...ShopFragment
    }
  }
`;

export const useSite = makeQuery<SiteUri, {}>(siteUri);

const userOperatePageEvent = gql`
  ${userOperatePageEventFragment}
  query UserOperatePageEvent(
    $filter: UserOperatePageEventFilterInput
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    userOperatePageEvent(
      filter: $filter
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      totalCount
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...UserOperatePageEventFragment
        }
      }
    }
  }
`;

export const userOperatePageEventQuery = makeQuery<
  UserOperatePageEvent,
  UserOperatePageEventVariables
>(userOperatePageEvent);
